module.exports = __webpack_public_path__ + "img/personal-web05.a75d182a.png";